import * as PIXI from 'pixi.js';

export class ResourcesStats {
    static getPixiCachedTexturesAllocatedMemory() {
        return Object.entries(PIXI.utils.TextureCache)
            .map(([_, t]) => {
                const textureSize =
                    (t.baseTexture.realWidth * t.baseTexture.realHeight * 4) / 1_000_000;
                return textureSize;
            })
            .reduce((acc, curr) => acc + curr);
    }

    static getPixiCachedTexturesNumber() {
        return Object.keys(PIXI.utils.TextureCache).length;
    }
}
